import React, { useState, useEffect, useCallback } from "react";
import { FiSearch, FiPlus } from "react-icons/fi";
import SelectRangeButton from "../common/select-range-button.jsx";
import { getProductLdistApi } from "./vendor_api";
import { ReactComponent as EditIc } from "../../assets/svg/edit_ic.svg";
import { ReactComponent as DeleteIc } from "../../assets/svg/delete_ic.svg";
import "./vendorView.css";
import ReactPaginate from "react-paginate";
import { Dropdown } from "react-bootstrap";
import { ReactComponent as DownArrowIc } from "../../assets/svg/down_arrow_ics.svg";
import { ReactComponent as RarIc } from "../../assets/svg/rar_ic.svg";
import { ReactComponent as LarIc } from "../../assets/svg/lar_ic.svg";
import { format } from "date-fns";
import { useNavigate } from "react-router-dom";
import DeleteModal from "../common/deleteModel.js";
import { deleteProductApi } from "../Product/productApi.js";
const ProductTab = ({ vendorId, vendorName, onShowSnackbar }) => {
  const navigate = useNavigate();
  const [dateRange, setDateRange] = useState(null);
  const [hoveredIndex, setHoveredIndex] = useState(null);
  const [contacts, setContacts] = useState([]);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [itemOffset, setItemOffset] = useState(0);
  const [search, setSearch] = useState("");
  const [pageCount, setPageCount] = useState(0);
  const [totalCount, setTotalCount] = useState(0);
  const handlePageClick = useCallback((event) => {
    setItemOffset(event.selected);
  }, []);
  const getContactList = async () => {
    const start = dateRange?.start;
    const end = dateRange?.end;

    const formattedStart = start ? format(start, "yyyy-MM-dd") : null;
    const formattedEnd = end ? format(end, "yyyy-MM-dd") : null;

    console.log("Raw Start Date:", start);
    console.log("Raw End Date:", end);
    console.log("Formatted Start Date:", formattedStart);
    console.log("Formatted End Date:", formattedEnd);

    try {
      const param = {
        limit: itemsPerPage,
        skip: itemOffset * itemsPerPage,
        search: search,
        from_date: formattedStart,
        to_date: formattedEnd,
        vendor_id: vendorId,
      };
      const response = await getProductLdistApi(param);
      if (response.data.success === true) {
        const fetchedProject = response.data.products ?? [];
        setTotalCount(response.data.total_rec ?? 0);
        setPageCount(response.data.total_pgs ?? 0);
        setContacts(fetchedProject);
      }
    } catch (err) {
      console.error("Error fetching vendor:", err);
    } finally {
    }
  };

  useEffect(() => {
    getContactList();
  }, [itemsPerPage, dateRange, itemOffset, search]);

  const [isOpenDelete, setIsOpenDelete] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const deleteProducts = async () => {
    // setIsLoading(true);
    try {
      const response = await deleteProductApi(deleteId);
      console.log("response....", response);
      if (response.data.success === true) {
        getContactList();
        onShowSnackbar(
          response.data.message ?? "",
          response.data.success ?? false,
        );

        setDeleteId(null);
        setIsOpenDelete(false);
      } else {
        onShowSnackbar(
          response.data.message ?? "",
          response.data.success ?? false,
        );
      }
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
      //   setIsLoading(false);
    }
  };

  useEffect(() => {
    if (deleteId !== null) {
      setIsOpenDelete(true);
    }
  }, [deleteId]);
  return (
    <div>
      <DeleteModal
        title={"product"}
        isOpen={isOpenDelete}
        onClose={() => setIsOpenDelete(false)}
        onDelete={deleteProducts}
      />
      <div className="header-bar">
        {/* Left */}
        <div className="header-left">
          <span className="fs-16 fw-600 textcolor">
            Products - {totalCount}
          </span>
        </div>

        {/* Right */}
        <div className="header-right">
          <div className="header-center">
            <FiSearch className="search-icon" />
            <input
              type="text"
              placeholder="Search..."
              className="search-input"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
          </div>
          <button
            className="contact-new-btn"
            onClick={() => {
              navigate("/product/create", {
                state: {
                  from: "vendor",
                  vendorId: String(vendorId),
                  vendorName: vendorName || "",
                  activeTab: "product",
                },
              });
            }}
          >
            <FiPlus size={16} />
            <span>New</span>
          </button>

          <SelectRangeButton
            onChange={(range) => {
              setDateRange(range);
              console.log("Selected Range:", range);
            }}
          />
        </div>
      </div>

      {/* Contacts Table */}
      <div style={{ marginTop: "20px" }}>
        <table className="contact-table">
          <thead>
            <tr>
              <th>Product name</th>
              <th>Code</th>
              <th>Group</th>
              <th>Orgin</th>
              <th>Status</th>
            </tr>
          </thead>

          <tbody>
            {contacts.map((contact, index) => (
              <tr
                key={contact.id}
                style={{
                  cursor: "pointer",
                }}
                onMouseEnter={() => setHoveredIndex(index)}
                onMouseLeave={() => setHoveredIndex(null)}
                onClick={() => {
                  navigate("/product/view", {
                    state: {
                      from: "vendor",
                      vendorId: String(vendorId),
                      activeTab: "product",
                      id: contact.id,
                    },
                  });
                }}
              >
                <td
                  className="fs-14 fw-500 textcolor"
                  style={{
                    marginLeft: "20px",
                  }}
                >
                  {contact.name}
                </td>
                <td className="fs-14 fw-500 textcolor">{contact.code}</td>
                <td className="fs-14 fw-500 textcolor">
                  {contact.item_group ?? "-"}
                </td>
                <td className="fs-14 fw-500 textcolor">
                  {contact.origin ?? "-"}
                </td>
                <td className="fs-14 fw-500 textcolor">
                  {contact.status === true ? "Active" : "Inactive"}
                </td>

                {hoveredIndex === index && (
                  <div className="row-actions ">
                    <div
                      onClick={(e) => {
                        e.stopPropagation();
                        navigate("/product/create", {
                          state: {
                            from: "vendor",
                            vendorId: String(vendorId),
                            vendorName: vendorName || "",
                            activeTab: "product",
                            id: contact.id,
                          },
                        });
                      }}
                      className="action-btn"
                    >
                      <EditIc />
                    </div>

                    <div
                      onClick={(e) => {
                        e.stopPropagation();
                        setDeleteId(contact.id);
                      }}
                      className="action-btn"
                    >
                      <DeleteIc />
                    </div>
                  </div>
                )}
              </tr>
            ))}
          </tbody>
        </table>

        {/* Pagination */}
        <div className="py-3 d-flex justify-content-between align-items-center flex-wrap gap-3">
          <Dropdown>
            <span className="fs-13 fw-500 textdrkColor">
              Records per page: &nbsp;
            </span>
            <Dropdown.Toggle
              id="dropdown-pagination"
              className="bg-transparent pagination-color border-0 custom-dropdown-toggle p-0"
              style={{
                outline: "none",
                boxShadow: "none",
              }}
            >
              <span
                className="bg-white textcolor no-of-rows rounded-3 px-2 py-2"
                style={{
                  border: "1px solid #EBEBEB",
                  transition: "all 0.2s ease-in-out",
                  display: "inline-block",
                }}
              >
                {itemsPerPage} <DownArrowIc />
              </span>
            </Dropdown.Toggle>
            <Dropdown.Menu
              className="my-2"
              style={{ minWidth: "unset", width: "30%" }}
            >
              {[5, 10, 25, 50, 75, 100].map((size) => (
                <Dropdown.Item
                  key={size}
                  onClick={() => {
                    setItemsPerPage(size);
                  }}
                  active={itemsPerPage === size}
                  className="text-center"
                >
                  {size}
                </Dropdown.Item>
              ))}
            </Dropdown.Menu>
          </Dropdown>

          <div className="d-flex align-items-center gap-2">
            <ReactPaginate
              previousLabel={
                <div
                  className="rounded-5 bg-white d-flex align-items-center justify-content-center"
                  style={{
                    width: "32px",
                    height: "32px",
                  }}
                >
                  <LarIc />
                </div>
              }
              nextLabel={
                <div
                  className="rounded-5 bg-white d-flex align-items-center justify-content-center"
                  style={{
                    width: "32px",
                    height: "32px",
                  }}
                >
                  <RarIc />
                </div>
              }
              breakLabel={"..."}
              pageCount={pageCount + 1}
              marginPagesDisplayed={2}
              pageRangeDisplayed={3}
              onPageChange={handlePageClick}
              containerClassName={"pagination"}
              activeClassName={"active"}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductTab;
